import { MessagesScreen } from '~/components/domain/messages/MessagesScreen';

export default function MessagesInbox() {
  
  return <MessagesScreen initialMessageType="inbox" />;
} 